<form *ngIf="personalGuardianInfo"  [formGroup]="personalGuardianInfo" class="editForm" novalidate>
  <h5>Parent / Guardian's Information</h5><br/>

  <div class="" id="pills-info" role="tabpanel" aria-labelledby="pills-info-tab">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label >
            Guardian Name
            <small class="text-muted">(required)</small>
          </label>
          <input type="text" formControlName="Name" class="form-control"  placeholder="Guardian Name" >
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label >
            Relationship to Applicant <small class="text-muted">(required)</small>
          </label>
          <select formControlName="RelationshipToStudentId" class="form-control">
              <option value=""> Relationship to Applicant</option>
              <option *ngFor="let item of relationships" value="{{item.ValueId}}">
                {{item.DisplayValue}}
               </option>
            </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label >Postal Address <small class="text-muted">(required)</small></label>
          <input type="text" class="form-control" formControlName="AddressLine1"  placeholder="" >
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label >Residential Address</label>
          <input type="text" class="form-control" formControlName="ResidentialAddress1" placeholder="" >
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label >Email Address <small class="text-muted">(required)</small></label>
          <input formControlName="Email" type="email" class="form-control"  placeholder="example@gmail.com" >
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label >Occupation</label>
          <select formControlName="OccupationId" class="form-control">
            <option value=""> Select Occupation</option>
            <option *ngFor="let item of occupations" value="{{item.ValueId}}">
              {{item.DisplayValue}}
             </option>
          </select>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label >
            City / Town <small class="text-muted">(required)</small>
          </label>
          <input type="text" formControlName="City" class="form-control"  placeholder="City or Town" >
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label >
            If University Staff <small class="text-muted">(Specify Position)</small>
          </label>
          <input formControlName="StaffPosition"  class="form-control"  placeholder="Position">
        </div>
      </div>


      <div class="col-md-6">
          <div class="form-group">
            <label >
              Fax Number
            </label>
            <input type="text" formControlName="OtherNumber" class="form-control"  placeholder="Fax No">
          </div>
        </div>




      <div class="col-md-6">
        <div class="form-group">
          <label >
            Telephone Number<small class="text-muted">(required)</small>
          </label>
          <input type="text" formControlName="PrimaryNumber" class="form-control"  placeholder="Telephone No" >
        </div>
      </div>


      <div class="col-md-6" *ngIf="!isForignStudent()">
          <div class="form-group">
            <label >Region <small class="text-muted">(required)</small></label>
            <select formControlName="RegionId" class="form-control">
                <option value=""> Select Region</option>
                <option *ngFor="let item of regions" value="{{item.ValueId}}">
                  {{item.DisplayValue}}
                 </option>
              </select>
          </div>
        </div>

    </div>

    <!-- <pre>{{ personalGuardianInfo.value | json }}</pre>
    <h4>{{personalGuardianInfo.valid}}</h4> -->
    <button class="btn btn-default waves-effect waves-light m-1 float-left" (click)="goToPrevious(personalGuardianInfo)"><i class="fa fa-backward"></i> Go Back</button>
    <button class="btn btn-primary waves-effect waves-light m-1 float-right" id="next" [disabled]="!personalGuardianInfo.valid" (click)="goToNext(personalGuardianInfo)">Save &amp; Continue</button>

  </div>
</form>
